import { CMSApi } from 'api';
import { ArrowRight } from 'assets/icons';
import { checkLinkForRegistration } from 'features/promotion/utility/utility';
import { History, LocationState } from 'history';
import { t } from 'i18next';
import { Dispatch, FC } from 'react';
import Button from 'shared/components/form/button';
import { APP_URL } from 'shared/constants/common';
import { isMobile } from 'shared/util/utility';
import { addNotification } from '../../../../shared/components/toast';
import { showLoginModal } from '../../../login/store/login.action';
import { PrimaryButton } from '../../store/promotionDetails.action';
import './styles.scss';

interface Props {
	promotionId: string;
	isUserJoined?: boolean;
	isUserLogged?: boolean;
	dispatch: Dispatch<any>;
	primaryButton?: PrimaryButton;
	getCustomerAndAccountData: () => Promise<void>;
	isPromoButton?: boolean;
	history: History<LocationState>;
}

const SignUpPromoButton: FC<Props> = ({
	promotionId,
	isUserJoined,
	isPromoButton,
	isUserLogged,
	dispatch,
	primaryButton,
	getCustomerAndAccountData,
	history,
}) => {
	if (isUserLogged && checkLinkForRegistration(primaryButton?.link)) {
		return null;
	}

	const goToLogin = () => {
		if (isMobile()) {
			history.push(APP_URL.login, window.location.pathname);
		} else {
			dispatch(showLoginModal());
		}
	};

	const handleSignUpClick = async () => {
		if (!isUserLogged) {
			goToLogin();
			return;
		}

		await CMSApi.getPromotionSignUp(promotionId)
			.then(() => {
				addNotification('success', 'Dołączyłeś do promocji.');
				getCustomerAndAccountData();
			})
			.catch(() => {
				addNotification('error', 'Wystąpił błąd, spróbuj ponownie.');
			});
	};

	return (
		<div className="SignUpPromo">
			{isUserJoined || !isPromoButton ? (
				<a href={primaryButton?.link} className="SignUpButtonWrapper">
					<Button className="JoinButton">
						{primaryButton?.text} <ArrowRight />
					</Button>
				</a>
			) : (
				<Button onClick={handleSignUpClick} className="SingUpButton">
					{t('promotionSignUpButton')}
				</Button>
			)}
		</div>
	);
};

export default SignUpPromoButton;
